<template>
    <div class="container">
        <div class="label">
                 <v-label>{{label}}</v-label>
        </div>
        <v-row no-gutters>
            <v-col>
                <v-list dense class="PermissionSelector">
                    <v-list-item-group
                            v-model="selectedForAdding"
                            multiple
                            color="indigo"
                    >
                    
                     <v-list-item
                        v-for="(item,i) in permissionList"
                        :key="i"
                        active-class="primary--text text--accent-4"
                    >
                     <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                            <v-list-item-title v-text="item.displayName"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            color="primary accent-4"
                            @click.stop="toggle"
                            ></v-checkbox>
                        </v-list-item-action>
                        </template>
                    </v-list-item>
                    
                    </v-list-item-group>
                </v-list>
            </v-col>
            <v-col align="center" align-self="center" fill-height cols="1">
            
                 <v-btn fab small rounded @click="add" color="primary">>></v-btn>
                 <br/>
                 <v-btn fab small rounded @click="remove" color="primary" style="top:10px">&lt;&lt;</v-btn>
            </v-col>
                <v-col>
                     <v-list dense class="PermissionSelector">
                    <v-list-item-group
                            v-model="selectedForRemove"
                            multiple
                            color="indigo"
                    >
                    
                     <v-list-item
                        v-for="(item,i) in selectedPermission"
                        :key="i"
                        active-class="primary--text text--accent-4"
                    >
                        <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                            <v-list-item-title v-text="item.displayName"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            color="primary accent-4"
                            @click.stop="toggle"
                            ></v-checkbox>
                        </v-list-item-action>
                        </template>
                    </v-list-item>
                    
                    </v-list-item-group>
                </v-list>
                </v-col>
        </v-row>
    </div>
</template>
<script>
import VInput from 'vuetify/lib/components/VInput/VInput.js';

export default {
    name: 'PermissionInput',
    props:['label','value','items'],
    data(){
        return{
            permissionList:[],
            selectedForAdding:[],
            selectedForRemove:[],
            selectedPermission:[]
        }
    },
    extends: VInput,
    created() {
        if(this.items){
            this.permissionList = this.items;
            this.removeSeletedPermission();
        }
        if(this.value) {
           this.selectedPermission = this.value;
           this.removeSeletedPermission();
        }
        this.emitChange();
    },
    watch:{
         items(val){
           if(val && this.permissionList != val) {
            this.permissionList = val;
            this.removeSeletedPermission();
           }
        },
        value(val){
           if(val && this.selectedPermission != val) {
            this.selectedPermission = val;
            this.removeSeletedPermission();
           }
        }
    },
    mounted(){
        this.selectedForAdding = [];
        this.selectedForRemove = [];
    },
    methods:{
        emitChange(){
            this.$emit('input', this.selectedPermission)
        },
        add(){
            const elementToRemove= [];
            this.selectedForAdding.forEach( index => {
                const element = this.permissionList[index];
                //add to selected permission list
                this.selectedPermission.push(element);
                //remove from source
                elementToRemove.push(element)
            });

            elementToRemove.forEach( e =>{
                this.permissionList = this.permissionList.filter(ele => ele.repGroup != e.repGroup);
            });

            this.selectedForAdding = [];
            this.permissionList.sort(this.compare);
            this.selectedPermission.sort(this.compare);
            this.emitChange();

        },
        remove(){
            const elementToRemove = [];
            this.selectedForRemove.forEach( index => {
                elementToRemove.push(this.selectedPermission[index]);
            });
            elementToRemove.forEach( e =>{
                //remove from selected permission list
                this.selectedPermission = this.selectedPermission.filter(ele => ele.repGroup != e.repGroup);
                //add back to source
                this.permissionList.push(e);
            });
            this.selectedForRemove = [];
            this.permissionList.sort(this.compare);
            this.selectedPermission.sort(this.compare);
            this.emitChange();
        },
        removeSeletedPermission(){
            this.$nextTick(function(){
                this.selectedPermission.forEach(e =>{
                //remove seleted permission from permissionList
                this.permissionList = this.permissionList.filter(ele => ele.repGroup != e.repGroup);
                 });
            })
            this.permissionList.sort(this.compare);
            this.selectedPermission.sort(this.compare);
            
        },
        compare( a, b ) {
            if ( a.repGroup < b.repGroup ){
                return -1;
            }
            if ( a.repGroup > b.repGroup ){
                return 1;
            }
            return 0;
        }
    }
}
</script>
<style lang="scss" scoped>
    .label{
        background: white;
        width:90px;
        margin-top: -23px;
        padding-left: 5px;
    }
    .container{
         border: 2px lightgray solid;
    }
    .PermissionSelector{
        height: 220px;
        border: 2px lightgray solid;
        overflow-y: scroll;
    }
</style>